module.exports = __webpack_public_path__ + "static/media/computer.0e862caa.png";